import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core';
import {FormBase} from './form-base';
import {FormGroup, Validators} from '@angular/forms';
import {DatePickerShamsi} from '@vendor/shared-component/date-picker-shamsi/date-picker-shamsi';

@Component({
  selector: 'app-form-inputs',
  templateUrl: './form-inputs.component.html',
  styleUrls: ['./form-inputs.component.scss']
})
export class FormInputsComponent implements OnInit {
  randomName: number;
  @Output() customEvent = new EventEmitter();
  dateErr = false;
  isClicked = false;
  checkedList = [];
  constructor() {
    this.randomName = Math.floor(Math.random() * 1000001);
  }
  config: DatePickerShamsi = {
    caption: 'تا تاریخ',
    calendarCaption: 'نوشتن با تقویم',
    count: -110,
    calendarPickerStyle: {
      width: '27%',
      background: '#e4e1e6',
      borderRadius: '10px',
      padding: '5px',
    }
  };

  @Input() field: FormBase<string>;
  @Input() form: FormGroup;
  get isValid() { return this.form.controls[this.field.key].valid; }
  get getError() {
    return this.form.controls[this.field.key].touched && this.form.controls[this.field.key].errors ; }
  get showLable() { return this.form.controls[this.field.key].value; }
  get datePickerConfig() {
    this.config.caption = this.field.title;
    return this.config;
  }
  ngOnInit(): void {
    this.mySetValidators();
  }
  mySetValidators() {
    if (this.field.key === 'CODE_MELLI') {
        this.form.controls[this.field.key].setValidators([Validators.pattern(/^[0-9]\d*$/), Validators.minLength(10)]);
    } else if (this.field.key === 'MOBILE') {
          this.form.controls[this.field.key].setValidators([Validators.pattern('09[0-9]{9}'), Validators.minLength(10)]);
    }
    if (this.field.key === 'MULTI_SELECT') {
      if (this.field.value) {
        let temp = this.field.value.split('[').join('');
        temp = temp.split(']').join('');
        temp = temp.split('"').join('');
        const temp2 = temp.split(',');
        const uniqueNames = [...new Set(temp2)];
        if (uniqueNames.length > 0) {
          uniqueNames.forEach(element => {
            this.checkedList.push(element);
          });
        }
      }
    }
    this.form.controls[this.field.key].updateValueAndValidity();
    if (this.field.value) {
      this.customEvent.emit();

    }
  }

  getDate(event, key) {
    this.dateErr = false;
    if ( event > this.field.maxDate || event < this.field.minDate) {
      this.dateErr = true;
  }
    this.form.controls[key].setValue(event);
    this.customEvent.emit();
  }
  getCheckBoxes(event, value) {
    this.isClicked = true;
    if (event.srcElement.checked) {
      this.checkedList.push(value);
    } else {
      this.checkedList = this.checkedList.filter(item => item !== value);
    }
    this.form.controls[this.field.key].setValue(this.checkedList.toString());
    if (this.checkedList.length > 1 && this.checkedList.length < 5) {
      this.customEvent.emit();
    }
  }
}
